import { GeneratedContent } from "@/types/content";
import { Play, Volume2, Settings, Maximize2 } from "lucide-react";

interface VideoPreviewProps {
  content: GeneratedContent;
}

export const VideoPreview = ({ content }: VideoPreviewProps) => {
  return (
    <div className="max-w-3xl mx-auto">
      <div className="bg-black rounded-lg overflow-hidden">
        {/* Video preview area */}
        <div className="relative aspect-video bg-gray-900 flex items-center justify-center">
          <div className="absolute inset-0 flex items-center justify-center">
            <button className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-colors">
              <Play className="h-8 w-8 text-white fill-white" />
            </button>
          </div>
          
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
            <div className="flex items-center justify-between">
              {/* Progress bar */}
              <div className="w-full flex items-center gap-4">
                <span className="text-white text-xs">0:00</span>
                <div className="h-1 bg-white/30 rounded-full flex-1 overflow-hidden">
                  <div className="h-full w-0 bg-white rounded-full"></div>
                </div>
                <span className="text-white text-xs">
                  {content.metadata?.duration || "5:30"}
                </span>
              </div>
              
              {/* Controls */}
              <div className="flex items-center gap-3 ml-4">
                <button className="text-white hover:text-white/80">
                  <Volume2 className="h-5 w-5" />
                </button>
                <button className="text-white hover:text-white/80">
                  <Settings className="h-5 w-5" />
                </button>
                <button className="text-white hover:text-white/80">
                  <Maximize2 className="h-5 w-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Video title and script */}
      <div className="mt-6 space-y-6">
        <h1 className="text-2xl font-bold">{content.title}</h1>
        
        <div className="space-y-4">
          <h2 className="text-lg font-semibold border-b pb-2">Video Script</h2>
          <div className="prose max-w-none dark:prose-invert">
            <div className="whitespace-pre-wrap">{content.content}</div>
          </div>
        </div>
      </div>
    </div>
  );
}; 